export default "__VITE_ASSET__BMcn_Od5__"